import React, { useState, useEffect, useMemo, useRef } from "react";
import { Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";

const CommonDropdown = ({
  name,
  label,
  options = [],
  validationFn,
  control,
  errors,
  placeholder = "Seleziona un'opzione",
  disabled = false,
  defaultValue,
  onFocus,
  pharmacyOptionFn = () => { }
}) => {

  const [searchValue, setSearchValue] = useState("");
  const [dropdownOptionsval, setDropdownOptionsval] = useState([]);
  const prevOptionsRef = useRef();

  useEffect(() => {
    const optionsChanged = JSON.stringify(prevOptionsRef.current) !== JSON.stringify(options);

    if (optionsChanged) {
      setSearchValue("");
      prevOptionsRef.current = options;
    }

    if (options?.length) {
      setDropdownOptionsval([...options]);
    } else {
      let enhancedOptions = [{ label: "", value: "" }]?.filter((obj) => !!obj?.value);
      setDropdownOptionsval([...enhancedOptions]);
    }
  }, [options]);

  const filteredOptions = useMemo(() => {
    if (searchValue?.trim()?.length === 0) {
      return dropdownOptionsval;
    } else {
      const filtered = dropdownOptionsval?.filter((opt) =>
        opt?.label?.toLowerCase()?.includes(searchValue?.toLowerCase())
      );
      return filtered;
    }
  }, [searchValue]);

  return (
    <div className="p-field common-p-dropdown dropdown-container custom-dropdown-container">
      {label && (
        <label htmlFor={name} className="mt-2 fw-bold">
          {label}
        </label>
      )}
      <>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={{
            validate: (value) => {
              const { errorFlag, error } = validationFn({
                FieldName: name,
                value,
              });
              if (errorFlag) {
                return error;
              }
              return true;
            },
          }}
          render={({ field }) => (
            <Dropdown
              editable
              style={{ marginBottom: 20 }}
              id={name}
              {...field}
              options={searchValue?.length ? filteredOptions?.filter(fd => !fd.label?.includes("undefined")) : dropdownOptionsval?.filter(fd => !fd.label?.includes("undefined"))}
              placeholder={placeholder}
              onChangeCapture={(e) => setSearchValue(e.target.value || "")}
              disabled={disabled}
              className="u-shaped-dropdown mt-1"
              appendTo="self"
              filterBy="label"
              onChange={(e) => {
                if (name === "asldropdown" && typeof e?.value != "string") {
                  pharmacyOptionFn(e?.value, "aslChange");
                }
                field?.onChange(e?.value);
                setSearchValue("");

                if (typeof e?.value != "number") {
                  console.log("Number is not coming");
                }
              }}
              onBeforeInput={(e) => {
                if (e?.data === " " && e?.data?.length > 0) {
                  e?.preventDefault();
                }
              }}
              onFocus={onFocus}
              emptyMessage="Nessuna opzione disponibile"
            />
          )}
        />
      </>

      {errors?.[name] && (
        <small className="p-error">{errors[name]?.message}</small>
      )}
    </div>
  );
};

export default CommonDropdown;
